var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":['Identity', 'BasicInfo', 'AddressBook']}},[_c('router-view')],1),_c('Loading',{attrs:{"isLoading":_vm.showLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }